'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

exports.default = action;

var _createMemoizingGetter = require('nanotools/lib/createMemoizingGetter');

var _createMemoizingGetter2 = _interopRequireDefault(_createMemoizingGetter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getActionDispatcherDescriptor(proto, key, actionCreator) {
  var actionDispatcher;
  actionDispatcher = function actionDispatcher() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return this.store.dispatch(actionCreator.apply(this, args));
  };
  return {
    configurable: true,
    get: (0, _createMemoizingGetter2.default)(proto, key, actionDispatcher, function () {
      return actionDispatcher.bind(this);
    })
  };
}

function defineActionDispatcher(proto, key, actionCreator) {
  return (0, _defineProperty2.default)(proto, key, getActionDispatcherDescriptor(proto, key, actionCreator));
}

function action(opts) {
  var isDispatcher, withDispatcher;
  if (opts) {
    withDispatcher = opts.withDispatcher, isDispatcher = opts.isDispatcher;
  }
  return function (proto, key, descriptor) {
    var originalActionCreator, ref;
    originalActionCreator = descriptor.value;
    if (typeof originalActionCreator !== 'function') {
      throw new Error('redux-components: @action decorator (applied to ' + ((ref = proto.constructor) != null ? ref.name : void 0) + '.' + key + ') can only be applied to action creators.');
    }
    if (isDispatcher) {
      return getActionDispatcherDescriptor(proto, key, originalActionCreator);
    } else {
      if (withDispatcher) {
        defineActionDispatcher(proto, withDispatcher, originalActionCreator);
      }
      return {
        configurable: true,
        get: (0, _createMemoizingGetter2.default)(proto, key, originalActionCreator, function () {
          return originalActionCreator.bind(this);
        })
      };
    }
  };
}